import React from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  Avatar,
  Container,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import {
  GroupAdd,
  CheckCircle,
  Visibility,
  Warning,
  Delete,
  Error,
  Info,
} from "@mui/icons-material";

const activities = [
  {
    icon: <GroupAdd color="primary" />,
    event: "New user created",
    user: "John Doe (Admin)",
    company: "Acme Corporation",
    time: "5 minutes ago",
  },
  {
    icon: <CheckCircle color="success" />,
    event: "Payment received",
    user: "System",
    company: "Global Services",
    time: "1 hour ago",
  },
  {
    icon: <Visibility color="secondary" />,
    event: "Admin access used",
    user: "Sarah Johnson",
    company: "TechTron Inc.",
    time: "3 hours ago",
  },
  {
    icon: <Warning sx={{ color: "#fbc02d" }} />,
    event: "Usage limit warning",
    user: "System",
    company: "Widget Industries",
    time: "6 hours ago",
  },
  {
    icon: <Delete sx={{ color: "#ef5350" }} />,
    event: "User deleted",
    user: "Robert Smith (Admin)",
    company: "StarCall Solutions",
    time: "Yesterday",
  },
];
const columns = ["Event", "User", "Company", "Time"];

const notifications = [
  {
    icon: <Error color="error" />,
    title: "Billing Error",
    text: "Payment for TechTron Inc. failed. Please check payment details.",
    time: "10 minutes ago",
    bgColor: "#ffeaea",
  },
  {
    icon: <Warning sx={{ color: "#fbc02d" }} />,
    title: "Usage Warning",
    text: "Widget Industries is at 95% of their monthly minutes allocation.",
    time: "2 hours ago",
    bgColor: "#fff8dc",
  },
  {
    icon: <Info color="info" />,
    title: "System Update",
    text: "New feature release: Advanced sentiment analysis now available.",
    time: "1 day ago",
    bgColor: "#e8f4ff",
  },
  {
    icon: <CheckCircle color="success" />,
    title: "Payment Received",
    text: "Global Services monthly payment of $9,936 processed successfully.",
    time: "2 days ago",
    bgColor: "#e7f9ed",
  },
];

const RecentActivities = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 9, mb: 4 }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <Paper
            elevation={2}
            sx={{ p: 3, borderRadius: 2, border: "1px solid #e5e7eb" }}
          >
            <Box display="flex" justifyContent="space-between" mb={2}>
              <Typography variant="body1">Recent Activities</Typography>
              <Typography
                variant="body2"
                color="primary"
                sx={{ cursor: "pointer" }}
              >
                View All
              </Typography>
            </Box>
            <Box sx={{ overflowX: "auto", height: 390 }}>
              <Table
                sx={{
                  minWidth: 650,
                  borderRadius: 2,
                  overflow: "hidden",
                }}
                size="small"
              >
                <TableHead sx={{ backgroundColor: "#f9fafb" }}>
                  <TableRow>
                    {columns.map((col, i) => (
                      <TableCell key={i} sx={{ fontWeight: 500, p: 2 }}>
                        {col}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {activities.map((item, idx) => (
                    <TableRow
                      key={idx}
                      sx={{
                        "&:hover": { backgroundColor: "#fafafa" },
                      }}
                    >
                      <TableCell sx={{ p: 2 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                          }}
                        >
                          <Avatar
                            sx={{
                              bgcolor: "transparent",
                              width: 20,
                              height: 20,
                            }}
                          >
                            {item.icon}
                          </Avatar>
                          <Typography variant="body2">{item.event}</Typography>
                        </Box>
                      </TableCell>
                      <TableCell sx={{ p: 2 }}>{item.user}</TableCell>
                      <TableCell sx={{ p: 2 }}>{item.company}</TableCell>
                      <TableCell sx={{ p: 2 }}>{item.time}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} md={4}>
          <Paper
            elevation={2}
            sx={{
              p: 3,
              borderRadius: 2,
              border: "1px solid #e5e7eb",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="body1">Alerts & Notifications</Typography>
              <Typography
                variant="body2"
                color="primary"
                sx={{ cursor: "pointer" }}
              >
                Mark All Read
              </Typography>
            </Box>
            <Box
              sx={{
                maxHeight: 400,
                overflow: "auto",
              }}
            >
              {notifications.map((note, idx) => (
                <Box
                  key={idx}
                  sx={{
                    backgroundColor: note.bgColor,
                    p: 2,
                    mt: 2,
                    borderRadius: 2,
                  }}
                >
                  <Box display="flex" alignItems="center" mb={1}>
                    {note.icon}
                    <Typography variant="subtitle2" sx={{ ml: 1 }}>
                      {note.title}
                    </Typography>
                  </Box>
                  <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                    {note.text}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {note.time}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default RecentActivities;
